export const selectSearchVisible = (state) => state.ui.search;
export const selectAuthVisible = (state) => state.ui.auth;
export const selectMenuVisible = (state) => state.ui.sideMenu;
export const selectLocalUserData = (state) => state.ui.region;
